import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom'
import './style.css';

class PageSubscribeCta extends Component {
  renderSubscribeLink() {
    const handleOnClick = e => {
      e.preventDefault();

      const { $ } = window;
      // Initialize modal first
      $('#subscribe-modal').modal();
      $('#subscribe-modal').modal('open');
    };

    return <Link onClick={handleOnClick} to="#subscribe/cta?location=page_data_table">Subscribe now</Link>
  }

  render() {
    const { subscription, bypass } = this.props.auth;
    // Only show if there supposed to be any pages, no subscription or npo bypass
    if (!subscription && this.props.pages.length > 0 && !bypass) {
      return (
        <div style={{textAlign: 'center'}} className="page-subscribe-cta">
          <p>Want more than 10 pages? {this.renderSubscribeLink()} to get unlimited page data for only $18.00 CAD / month.</p>
        </div>
      )
    }

    return null;
  }
}

function mapStateToProps({ auth, pages }) {
  return { auth, pages };
}

export default connect(mapStateToProps)(PageSubscribeCta);



// WEBPACK FOOTER //
// ./src/components/Dashboard/PageSubscribeCta.js